import IndigoApi from 'communication/IndigoApi';
import { Currency } from 'app/currencies/store/CurrencyState';
import RequestProgressService from 'requestProgress/RequestProgressService';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import without from 'lodash/without';

interface CurrencyServiceOptions {
    indigoApi: IndigoApi;
    requestProgressService: RequestProgressService;
}

export default class CurrencyService {
    private indigoApi: IndigoApi;
    private requestProgressService: RequestProgressService;

    private requestedCurrencies: string[] = [];

    public constructor(options: CurrencyServiceOptions) {
        this.indigoApi = options.indigoApi;
        this.requestProgressService = options.requestProgressService;
    }

    public async loadCurrencies(
        currencySymbols: string[]
    ): Promise<Currency[]> {
        const currenciesToLoad = without(
            currencySymbols.map((c) => c.toUpperCase()),
            ...this.requestedCurrencies
        );
        if (currenciesToLoad.length === 0) {
            return Promise.resolve([]);
        }

        this.requestedCurrencies.push(...currenciesToLoad);

        const apiCall = (options: ApiRequestOptions) =>
            this.indigoApi.loadCurrencies(currenciesToLoad, options);
        return await this.requestProgressService.invokeAndMonitorRequest(
            'loadCurrencies',
            apiCall
        );
    }
}
